import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { Topbar } from './Topbar';
import { ChatPanel } from '@/components/chat/ChatPanel';
import { ContactosSidebar } from '@/components/chat/ContactosSidebar';
import { IkalPanel } from '@/components/ikal/IkalPanel';
import { MobileBottomNav } from './MobileBottomNav';

export function AppLayout() {
  return (
    <div
      className="flex h-screen overflow-hidden md:p-5 md:gap-5"
      style={{ backgroundColor: '#dce9ff' }}
    >
      {/* Sidebar — solo desktop */}
      <div className="hidden md:contents">
        <AppSidebar />
      </div>

      {/* Columna principal */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden md:gap-5">
        <Topbar />
        <main
          className="flex-1 bg-white overflow-auto p-4 md:p-5 md:rounded-[2rem] pb-20 md:pb-5"
          style={{ border: '1px solid rgba(0,0,0,0.05)', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}
        >
          <Outlet />
        </main>
      </div>

      {/* ContactosSidebar — flex-child, solo desktop */}
      <div className="hidden md:contents">
        <ContactosSidebar />
      </div>

      {/* Paneles flotantes */}
      <ChatPanel />
      <IkalPanel />

      {/* Navegación mobile */}
      <MobileBottomNav />
    </div>
  );
}
